(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initQty();
    initGallery();
    initProduct();
    initCart();
  });


  /* ---------- Carrito: enviar el formulario al cambiar cantidades ---------- */
  function initCart() {
    document.querySelectorAll('form[action*="/cart"] input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (this.form) this.form.submit();
      });
    });
  }

  /* ---------- Menu movil ---------- */
  function initMenu() {
    var b = document.querySelector('[data-burger]');
    var m = document.querySelector('[data-mnav]');
    if (!b || !m) return;
    b.addEventListener('click', function () {
      m.classList.toggle('open');
      b.setAttribute('aria-expanded', m.classList.contains('open') ? 'true' : 'false');
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ----------------------------------------------------------
     Galeria: todas las imagenes ya estan en el DOM.
     Solo alternamos la clase .on — nunca cambiamos src,
     asi no hay parpadeos ni imagenes que no cargan.
  ---------------------------------------------------------- */
  function showImage(root, imageId) {
    if (!root || !imageId) return false;
    var target = root.querySelector('.gi[data-img="' + imageId + '"]');
    if (!target) return false;

    root.querySelectorAll('.gi').forEach(function (el) { el.classList.remove('on'); });
    target.classList.add('on');

    root.querySelectorAll('.gal-thumbs button').forEach(function (b) {
      b.classList.toggle('on', b.dataset.img === String(imageId));
    });
    return true;
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      root.querySelectorAll('.gal-thumbs button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showImage(root, btn.dataset.img);
        });
      });
    });
  }

  /* ---------- Dinero ---------- */
  function money(cents, format) {
    format = format || window.NIMBO_MONEY || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;

    function fmt(prec, thou, dec) {
      var n = (cents / 100).toFixed(prec).split('.');
      var whole = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return whole + (n[1] ? dec + n[1] : '');
    }

    var out;
    switch (m[1]) {
      case 'amount_no_decimals': out = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(0, '.', ','); break;
      default: out = fmt(2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ----------------------------------------------------------
     Producto: al elegir una opcion buscamos la variante que
     coincida en TODAS las opciones y actualizamos foto,
     precio, disponibilidad y el id que se manda al carrito.
  ---------------------------------------------------------- */
  function initProduct() {
    document.querySelectorAll('[data-product]').forEach(function (root) {
      var tag = root.querySelector('script[data-variants]') || document.querySelector('script[data-variants]');
      if (!tag) return;

      var variants;
      try { variants = JSON.parse(tag.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var gallery = root.querySelector('[data-gallery]');
      var idField = root.querySelector('[data-vid]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');
      var button = root.querySelector('[data-add]');
      var inputs = root.querySelectorAll('[data-opt]');

      function chosen() {
        var vals = [];
        inputs.forEach(function (input) {
          if (input.checked || input.tagName === 'SELECT') {
            vals[parseInt(input.dataset.opt, 10)] = input.value;
          }
        });
        return vals;
      }

      function match(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== undefined && v.options[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function update() {
        var v = match(chosen());

        // reflejar el valor elegido junto a la etiqueta de la opcion
        inputs.forEach(function (input) {
          if (!input.checked && input.tagName !== 'SELECT') return;
          var out = root.querySelector('[data-optval="' + input.dataset.opt + '"]');
          if (out) out.textContent = input.value;
        });

        if (!v) {
          if (button) { button.disabled = true; button.textContent = 'No disponible'; }
          return;
        }

        if (idField) idField.value = v.id;

        // la foto solo cambia si esa variante trae imagen propia
        if (v.image_id) showImage(gallery, v.image_id);

        if (priceEl) priceEl.textContent = money(v.price);

        if (compareEl) {
          var hasOffer = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.textContent = hasOffer ? money(v.compare_at_price) : '';
          compareEl.hidden = !hasOffer;
          if (saveEl) {
            saveEl.hidden = !hasOffer;
            if (hasOffer) {
              var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
              saveEl.textContent = '-' + pct + '%';
            }
          }
        }

        if (button) {
          button.disabled = !v.available;
          button.textContent = v.available
            ? button.dataset.textOk
            : button.dataset.textNo;
        }
      }

      inputs.forEach(function (input) { input.addEventListener('change', update); });
      update();
    });
  }
})();
